import styled from 'styled-components';

import { COLORS, DESKTOP } from '../../../../theme/tokens';
import { Text } from '../../../../components';

/** Lead paragraph under the section title explaining what the toggle controls. */
export const Lead = styled(Text)`
  display: block;
  margin: 0 0 4px;
  font-size: 14px;
  line-height: 1.5;
  color: ${COLORS.textMuted};
`;

/** The single consent row: label + hint on the left, toggle on the right. */
export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 4px 0;
`;

export const RowText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const RowTitle = styled(Text)`
  font-size: 15px;
  color: ${COLORS.text};
`;

export const RowHint = styled(Text)`
  font-size: 13px;
  color: ${COLORS.textMuted};
`;

export const SaveError = styled(Text)`
  font-size: 13px;
  color: ${COLORS.statusDanger};
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;

  ${DESKTOP} {
    align-items: center;
    border-top: 1px solid ${COLORS.hairline};
    padding-top: 20px;

    && > * {
      width: 50%;
    }
  }
`;
